import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserType } from 'src/app/_models/users/UserType';
import { AuthenticationService } from 'src/app/_services';
import { MicrosoftAuthService } from 'src/app/_services/users/MicrosoftAuthService';

@Component({
  selector: 'app-oauth-callback',
  templateUrl: './oauth-callback.component.html',
  styleUrls: ['./oauth-callback.component.scss']
})
export class OauthCallbackComponent implements OnInit {

  load = false;
  error = '';

  constructor(
    private router: Router,
    private microsoftAuthService: MicrosoftAuthService,
    private authenticationService: AuthenticationService, 
  ) {}

  async ngOnInit(): Promise<void> {
    const inProgress = sessionStorage.getItem('msal_login_in_progress');
    if (!inProgress) {
      this.router.navigate(['/prospect/login']);
      return;
    }
    try {
      this.load = true;
      const result = await this.microsoftAuthService.handleRedirectCallback();
      if (!result) {
        sessionStorage.removeItem('msal_login_in_progress');
        sessionStorage.removeItem('msal_return_url');
        this.router.navigate(['/prospect/login']);
        return;
      }
      this.authenticationService.handleMicrosoftCallback(result).subscribe({
        next: (user) => {
          const returnUrl = sessionStorage.getItem('msal_return_url') || '/app';
          sessionStorage.removeItem('msal_login_in_progress');
          sessionStorage.removeItem('msal_return_url');
          this.load = false;
          if (user?.type === UserType.AGENT_COMMERCIAL_SALE_ADMINISTRATION) {
            void this.router.navigate(['/client/project/list'], {
              queryParams: { type: 'ModeAgent' }
            });
            return;
          }
          this.router.navigateByUrl(returnUrl);
        },
        error: (err) => {
          console.error('Erreur login Microsoft -> back:', err);
          sessionStorage.removeItem('msal_login_in_progress');
          sessionStorage.removeItem('msal_return_url');
          this.error = 'Erreur lors de la connexion Microsoft.';
          this.load = false;
          this.router.navigate(['/prospect/login']);
        }
      });

    } catch (e) {
      console.error('Erreur callback Microsoft:', e);
      sessionStorage.removeItem('msal_login_in_progress');
      sessionStorage.removeItem('msal_return_url');
      this.load = false;
      this.router.navigate(['/prospect/login']);
    }
  }
}
